import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportService } from 'app/layout/export-overlay';
import { get } from 'lodash-es';
import { LOCALIZED_PROPERTIES_ADDRESS, BUSINESS_PARTNER_ADDRESS_BY_ONE_EXPORT_ID, BUSINESS_PARTNER_ADDRESS_BY_ONE_TITLE } from './business-partner.constants';
import AddressAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/address/address.entity';

@Injectable()
export class BusinessPartnerByOneAddressExport {

  constructor(private exportService: ExportService) {}

  private transformAddress(address: AddressAttributes, externalKeys: string, name: string) {
    return {
      externalKeys,
      name,
      address: get(address, 'address', ''),
      latitude: get(address, 'geolocationPoint[0]', ''),
      longitude: get(address, 'geolocationPoint[1]', ''),
      addressType: get(address, 'type.name', ''),
      country: get(address, 'locationOne.name', ''),
      department: get(address, 'locationTwo.name', ''),
      city: get(address, 'locationThree.name', ''),
      district: get(address, 'locationFour.name', ''),
      isPrincipal: get(address, 'isPrincipal', false) ? 'Sí' : 'No'
    };
  }

  export(format: ExportFileFormat, addresses: AddressAttributes[], externalKeys: string, name: string) {
    this.exportService.task({
      id: BUSINESS_PARTNER_ADDRESS_BY_ONE_EXPORT_ID,
      title: BUSINESS_PARTNER_ADDRESS_BY_ONE_TITLE,
      format: format,
      iterations: 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(BUSINESS_PARTNER_ADDRESS_BY_ONE_TITLE, LOCALIZED_PROPERTIES_ADDRESS);
      },
      next: (ctx: ExportContext) => {
        addresses.forEach((address) => {
          const item = this.transformAddress(address, externalKeys, name);
          ctx.processor.addToSection(BUSINESS_PARTNER_ADDRESS_BY_ONE_TITLE, item);
        });
        ctx.next();
      }
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(BUSINESS_PARTNER_ADDRESS_BY_ONE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
